/**
 * A time from the API as a Date, or null when there is none or it cannot be read.
 *
 * avrio-backend writes java.time.Instant fields as a NUMBER of epoch SECONDS with a fractional part
 * (JacksonJsonMapperConfig enables WRITE_DATES_AS_TIMESTAMPS), e.g. 1792164395.869225. `new Date(n)` reads a
 * number as MILLISECONDS, so a whole interview transcript showed as "Jan 21, 1970" (staging, 16 Oct 2026).
 * Strings are still accepted, ISO-8601 or a numeric string, so a record that does arrive as text keeps working.
 */
export const apiInstantToDate = (
  value: string | number | null | undefined,
): Date | null => {
  if (value === null || value === undefined) return null;
  let date: Date;
  if (typeof value === 'number') {
    date = new Date(value * 1000);
  } else {
    const text = value.trim();
    if (!text) return null;
    date = /^\d+(\.\d+)?$/.test(text)
      ? new Date(Number(text) * 1000)
      : new Date(text);
  }
  return Number.isNaN(date.getTime()) ? null : date;
};
